import { useEffect, useState } from "react";
import { motion } from "framer-motion";
import { LogoMark } from "./GeoShapes";
import { scrollToId } from "@/utils/scroll";

const LINKS = [
  { n: "01", label: "Chi sono", id: "chi-sono", testid: "nav-link-chi-sono" },
  { n: "02", label: "Servizi", id: "servizi", testid: "nav-link-servizi" },
  { n: "03", label: "Portfolio", id: "portfolio", testid: "nav-link-portfolio" },
  { n: "04", label: "Contatti", id: "contatti", testid: "nav-link-contatti" },
];

export default function HeaderNav() {
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <motion.header
      initial={{ y: -80, opacity: 0 }}
      animate={{ y: 0, opacity: 1 }}
      transition={{ duration: 0.7, ease: [0.22, 1, 0.36, 1], delay: 0.2 }}
      className={`fixed inset-x-0 top-0 z-50 border-b transition-[background-color,border-color,backdrop-filter] duration-500 ${
        scrolled
          ? "border-neutral-200 bg-white/80 backdrop-blur-xl"
          : "border-transparent bg-transparent"
      }`}
    >
      <div className="mx-auto flex h-[72px] max-w-[1400px] items-center justify-between px-5 sm:px-8">
        <button
          data-testid="nav-logo"
          onClick={() => window.__lenis?.scrollTo(0, { duration: 1.4 })}
          className="group flex items-center gap-3"
        >
          <LogoMark size={32} />
          <span className="text-left leading-none">
            <span className="block font-display text-sm font-bold tracking-tight">
              BEPPE FASINO
            </span>
            <span className="mt-1 block font-mono text-[10px] tracking-[0.18em] text-neutral-500">
              FOOD & BEVERAGE DESIGNER
            </span>
          </span>
        </button>

        <nav className="hidden items-center gap-7 lg:flex">
          {LINKS.map((l) => (
            <button
              key={l.id}
              data-testid={l.testid}
              onClick={() => scrollToId(l.id)}
              className="group font-mono text-xs tracking-wider text-neutral-600 transition-colors hover:text-ink"
            >
              <span className="text-cyan-brand transition-colors group-hover:text-magenta-brand">
                [{l.n}]
              </span>{" "}
              {l.label}
            </button>
          ))}
        </nav>

        <div className="flex items-center gap-4">
          <span className="hidden items-center gap-2 font-mono text-[10px] tracking-wider text-neutral-500 md:flex">
            <span className="h-2 w-2 rounded-full bg-green-500 animate-led" />
            DISPONIBILE · BARI / REMOTE
          </span>
          <a
            data-testid="nav-contact-cta"
            href="mailto:fasinogiuseppe52@gmail.com"
            className="bg-ink px-5 py-2.5 font-mono text-xs font-medium tracking-wider text-paper transition-colors duration-300 hover:bg-blue-brand"
          >
            SCRIVIMI
          </a>
        </div>
      </div>
    </motion.header>
  );
}
